module.exports = __webpack_public_path__ + "static/img/goodbit.5319a3d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/goodbit.png
// module id = W1Ea
// module chunks = 5